module.exports = __webpack_public_path__ + "static/media/pastor-alex.69566bcf.jpg";